export const processExtraParams = (
    extraParams: Record<string, string | number | boolean>,
): {
    stringParams: string[];
    stringValues: { string: string }[];
    intParams: string[];
    intValues: { long: number }[];
} => {
    const stringParams: string[] = [];
    const stringValues: { string: string }[] = [];
    const intParams: string[] = [];
    const intValues: { long: number }[] = [];

    for (const [key, value] of Object.entries(extraParams)) {
        if (typeof value === 'string') {
            stringParams.push(key);
            stringValues.push({ string: value });
        } else if (typeof value === 'number') {
            intParams.push(key);
            intValues.push({ long: value });
        } else if (typeof value === 'boolean') {
            stringParams.push(key);
            stringValues.push({ string: value.toString() }); // requires boolean to be cast as string
        }
    }

    return { stringParams, stringValues, intParams, intValues };
};
